<main class="calendar">

  <div *ngIf="canUpdateCalendar" style="text-align:right;margin-bottom:20px;">
    <button *ngIf="calendarType===CalendarType.Holiday&&user.managingOrgId!==DefaultOrg.OrgId" pButton type="button" class="action-secondary" icon="fa fa-copy" label="Copy Holidays"
            (click)="onClickCopyHolidays(calendarYear)">
    </button>
    <button *ngIf="addCalendarEnabled" pButton type="button" class="action-secondary" icon="fa fa-plus" (click)="handleDayClick($event)" [label]="'New '+calendarType|titleCase">
    </button>
  </div>

  <p-confirmDialog></p-confirmDialog>

  <p-fullCalendar [options]="calendarOptions" #fc [events]="calendarEvents"></p-fullCalendar>

  <p-dialog *ngIf="event&&dialogVisible" [(visible)]="dialogVisible" [header]="eventHeader" [modal]="true" [dismissableMask]="true"
            class="calendar-dialog" [responsive]="true" [resizable]="false"
            [style]="PrimeNgConfig.DialogStyle40">
    <form #dialogForm="ngForm">

      <div *ngIf="isSystemCalendar&&event?.id">
        <i class="fa fa-warning" style="color:red"></i>
        Updating or deleting a system calendar may affect existing transactions and the system to become inoperable! Please consult with Support before making any change.
      </div>

      <div *ngIf="isSystemCalendar" class="p-grid">
        <div *ngIf="!calendarInfoFrequency?.inFiscalYear" class="p-col-12 p-md-4 p-lg-4">
          <label>Year</label>
        </div>
        <div *ngIf="calendarInfoFrequency?.inFiscalYear" class="p-col-12 p-md-4 p-lg-4">
          <label>Fiscal Year</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <span style="padding-top:5px;">{{calendarYear}}</span>
        </div>
      </div>

      <div *ngIf="isSystemCalendar&&calendarInfoFrequency?.fiscalStartMonth" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Fiscal Start Month</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{calendarInfoFrequency.fiscalStartMonth}}
        </div>
      </div>

      <div *ngIf="!isSystemCalendar||(isSystemCalendar&&event?.id)" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label for="title">Name*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText id="title" name="title" [(ngModel)]="event.title" [disabled]="!canUpdateCalendar||isSystemCalendar" required/>
        </div>
      </div>

      <div *ngIf="!isSystemCalendar" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Description</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText id="description" name="description" [(ngModel)]="event.description" [disabled]="!canUpdateCalendar"/>
        </div>
      </div>
      <div *ngIf="calendarType!==CalendarType.Holiday&&calendarType!==CalendarType.Compliance" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label style="padding-top:5px;">Frequency*</label>
        </div>
        <div *ngIf="calendarType!==CalendarType.Accounting" class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="frequency" [placeholder]="Validation.DropdownPlaceholder" [options]="frequencyDropDown" [(ngModel)]="event.frequency"
                      (onChange)="setPartialCloseAndSecondStart(event.frequency, event.subtype)" [disabled]="!canUpdateCalendar" required></p-dropdown>
        </div>
        <div *ngIf="calendarType===CalendarType.Accounting" class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="frequency" [placeholder]="Validation.DropdownPlaceholder" [options]="accountingFrequencyDropDown" [(ngModel)]="event.frequency" [disabled]="!canUpdateCalendar"
                      required></p-dropdown>
        </div>
        <div *ngIf="!isSystemCalendar" class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="frequency" [placeholder]="Validation.DropdownPlaceholder" [options]="frequencyDropDown" [(ngModel)]="event.frequency" [disabled]="!canUpdateCalendar"></p-dropdown>
        </div>
      </div>

      <div *ngIf="showStartPeriodNumber" class="p-grid">
        <div>
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Start Period Number*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText id="startPeriodNumber" name="startPeriodNumber" pKeyFilter="pnum" pTooltip="Specify a period number for the first period in this year."
                   [(ngModel)]="event.startPeriodNumber"
                   [disabled]="!canUpdateCalendar" required/>
          </div>
        </div>
      </div>

      <div *ngIf="showStartDateCalendar||!isSystemCalendar" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Start Date*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-calendar name="start" dataType="string"
                      [dateFormat]="Format.PcalendarDate" [minDate]="minCalendarDate"
                      [maxDate]="maxCalendarDate" icon="fa fa-calendar" showIcon="true" [(ngModel)]="event.start" (onSelect)="onChangeTimesheetStartDate(event.start)"
                      [disabled]="!canUpdateCalendar"
                      required monthNavigator="true" [defaultDate]="defaultDate"></p-calendar>
        </div>
      </div>

      <div *ngIf="showPayrollOffset">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Payroll Period Offset</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText id="payrollPeriodOffset" name="payrollPeriodOffset" pKeyFilter="pnum"
                   pTooltip="Specify number of offset days between the first timesheet period and the first payroll period in the same year." [(ngModel)]="event.payrollPeriodOffset"
                   (blur)="onChangePayrollPeriodOffset(event.payrollPeriodOffset)"
                   [disabled]="!canUpdateCalendar&&calendarInfoFrequency?.inNextYear"/>
          </div>
        </div>
      </div>

      <div *ngIf="!showStartDateCalendar&&(timesheetOrPayrollMonthly||timesheetOrPayrollWeekly||accountingInvoicingCalendar)" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Start Date</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{event.start}}
        </div>
      </div>


      <div *ngIf="!showPayrollOffset&&timesheetWeekly">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Payroll Period Offset</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            {{event.payrollPeriodOffset}}
          </div>
        </div>
      </div>

      <div *ngIf="!isSystemCalendar && calendarType!==CalendarType.Holiday && calendarType!==CalendarType.Compliance" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>End Date*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-calendar name="end" dataType="string" [dateFormat]="Format.PcalendarDate" icon="fa fa-calendar" showIcon="true" [(ngModel)]="event.end" [disabled]="!canUpdateCalendar"
                      monthNavigator="true" rquired></p-calendar>
        </div>
      </div>

      <div *ngIf="event.frequency==EventFrequency.SemiMonthly">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>2nd Start Day*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText id="secondStart" name="secondStart" pKeyFilter="pnum" pTooltip="Specify second pay period start day of the semimonthly cycle in a month. Typically 15th of the month."
                   [(ngModel)]="event.secondStart" [disabled]="!canUpdateCalendar || secondStartSetBefore"
                   required/>
          </div>
        </div>
      </div>
      <div *ngIf="!isSystemCalendar&&calendarType!==CalendarType.Holiday&&calendarType!==CalendarType.Compliance" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>All Day</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-checkbox name="allDay" binary="checkbox" [(ngModel)]="event.allDay" [disabled]="!canUpdateCalendar"></p-checkbox>
        </div>
      </div>

      <div *ngIf="partialClose" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4" style="text-align:right;">
          <p-checkbox name="allowTimesheetPeriodClosedTwice" binary="true" [(ngModel)]="event.partialClose" required></p-checkbox>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <label style="color:red;text-align:left;">Selecting this frequency for your timesheet periods will require you to close your timesheets twice during each period. Confirm this is the option
            you want?</label>
        </div>
      </div>

    </form>
    <div class="main-clear"></div>
    <p-footer>
      <div style="margin-top:15px;text-align:right;">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel" (click)="dialogVisible=false"></button>
        <button pButton type="button" class="button-negative" icon="fa fa-trash" label="Delete" (click)="deleteEvent(event)"
                [disabled]="!event?.id || !canUpdateCalendar || partialClose && !event.partialClose"></button>
        <button pButton type="button" class="button-action" icon="fa fa-check" label="Save" (click)="saveEvent(event)"
                [disabled]="!dialogForm.form.valid || !canUpdateCalendar || partialClose && !event.partialClose"></button>
      </div>
    </p-footer>
  </p-dialog>
  <div class="main-clear"></div>
</main>
